import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import EditQRModal from '../components/EditQRModal';

const cardStyle = { background: '#fff', borderRadius: 10, padding: 16, boxShadow: '0 2px 8px rgba(0,0,0,.06)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 };
const badge = (text, color) => <span style={{ background: color || '#e0e7ff', color: color ? '#fff' : '#4338ca', padding: '2px 10px', borderRadius: 12, fontSize: 12, fontWeight: 600 }}>{text}</span>;

export default function Dashboard() {
  const [qrs, setQrs] = useState([]);
  const [categories, setCategories] = useState([]);
  const [search, setSearch] = useState('');
  const [sort, setSort] = useState('created_at');
  const [order, setOrder] = useState('desc');
  const [catFilter, setCatFilter] = useState('');
  const [newCat, setNewCat] = useState('');
  const [editingQR, setEditingQR] = useState(null);

  const load = async () => {
    const params = { search, sort, order };
    if (catFilter) params.category_id = catFilter;
    const [q, c] = await Promise.all([api.get('/qr', { params }), api.get('/categories')]);
    setQrs(q.data);
    setCategories(c.data);
  };

  useEffect(() => { load(); }, [search, sort, order, catFilter]);

  const addCategory = async () => {
    if (!newCat.trim()) return;
    await api.post('/categories', { name: newCat.trim() });
    setNewCat('');
    load();
  };

  const deleteQR = async id => {
    if (!window.confirm('Delete this QR code?')) return;
    await api.delete(`/qr/${id}`);
    load();
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h2>My QR Codes</h2>
        <Link to="/create" style={{ background: '#6366f1', color: '#fff', padding: '10px 20px', borderRadius: 8, textDecoration: 'none', fontWeight: 600 }}>+ Create QR</Link>
      </div>

      {/* Filters */}
      <div style={{ display: 'flex', gap: 10, marginBottom: 16, flexWrap: 'wrap' }}>
        <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search..." style={{ padding: 10, border: '1px solid #ddd', borderRadius: 8, flex: 1, minWidth: 200 }} />
        <select value={sort} onChange={e => setSort(e.target.value)} style={{ padding: 10, border: '1px solid #ddd', borderRadius: 8 }}>
          <option value="created_at">Date</option>
          <option value="title">Title</option>
          <option value="scan_count">Scans</option>
        </select>
        <button onClick={() => setOrder(o => o === 'asc' ? 'desc' : 'asc')} style={{ padding: '10px 14px', border: '1px solid #ddd', borderRadius: 8, background: '#fff', cursor: 'pointer' }}>
          {order === 'asc' ? '↑' : '↓'}
        </button>
        <select value={catFilter} onChange={e => setCatFilter(e.target.value)} style={{ padding: 10, border: '1px solid #ddd', borderRadius: 8 }}>
          <option value="">All categories</option>
          {categories.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
        </select>
      </div>

      {/* Category manager */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 20, alignItems: 'center', flexWrap: 'wrap' }}>
        {categories.map(c => <span key={c.id} style={{ background: c.color, color: '#fff', padding: '4px 12px', borderRadius: 12, fontSize: 13 }}>{c.name}</span>)}
        <input value={newCat} onChange={e => setNewCat(e.target.value)} placeholder="New category" onKeyDown={e => e.key === 'Enter' && addCategory()}
          style={{ padding: '6px 10px', border: '1px solid #ddd', borderRadius: 8, fontSize: 13 }} />
        <button onClick={addCategory} style={{ padding: '6px 12px', background: '#6366f1', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, cursor: 'pointer' }}>Add</button>
      </div>

      {/* QR List */}
      {qrs.length === 0 && <p style={{ color: '#888', textAlign: 'center', padding: 40 }}>No QR codes yet. Create one!</p>}
      {qrs.map(qr => (
        <div key={qr.id} style={cardStyle}>
          <div>
            <Link to={`/qr/${qr.id}`} style={{ fontWeight: 600, fontSize: 16, color: '#1a1a1a', textDecoration: 'none' }}>{qr.title}</Link>
            <div style={{ fontSize: 13, color: '#666', marginTop: 4 }}>
              {qr.target_url.substring(0, 50)}{qr.target_url.length > 50 ? '...' : ''} · <code>/q/{qr.code}</code>
              {qr.category_name && <> · {badge(qr.category_name, qr.category_color)}</>}
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <span style={{ fontWeight: 700, color: '#6366f1' }}>{qr.scan_count} scans</span>
            {!qr.is_active && badge('Inactive', '#ef4444')}
            <button onClick={() => setEditingQR(qr)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 18, color: '#aaa' }} title="Edit">✏️</button>
            <button onClick={() => deleteQR(qr.id)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 18, color: '#aaa' }}>🗑</button>
          </div>
        </div>
      ))}

      {editingQR && (
        <EditQRModal
          qr={editingQR}
          onClose={() => setEditingQR(null)}
          onSaved={() => { setEditingQR(null); load(); }}
        />
      )}
    </div>
  );
}
